import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MatchingAnalyticsState } from './models/matching-analytics-state.models';

export const selectMatchingAnalyticsState = createFeatureSelector<MatchingAnalyticsState>('matchingAnalytics');

export const selectMatchingOverview = createSelector(
  selectMatchingAnalyticsState,
  (state: MatchingAnalyticsState) => state.overview
);

export const selectMatchingLoading = createSelector(
  selectMatchingAnalyticsState,
  (state: MatchingAnalyticsState) => state.loading
);

export const selectMatchingError = createSelector(
  selectMatchingAnalyticsState,
  (state: MatchingAnalyticsState) => state.error
);
